import { IChuanDauRaChungChiSysRequest } from "../../../model/request/chuong-trinh-dao-tao/IChuanDauRaChungChiSysRequest";
import { IChuanDauRaChungChi } from "../../../model/response/chuong-trinh-dao-tao/IChuanDauRaChungChi";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eChuanDauRaChungChiActionsObj = {
    LOAD_START: undefined,
    LOAD_SUCCESS: {} as IChuanDauRaChungChi[],
    LOAD_ERROR: "",

    SYS_START: {} as IChuanDauRaChungChiSysRequest,
    SYS_SUCCESS: undefined,
    SYS_ERROR: "",
}

export const eChuanDauRaChungChiActionIds = generateActionTypeIds(eChuanDauRaChungChiActionsObj, "CHUAN_DAU_RA_CHUNG_CHI");
export type IChuanDauRaChungChiActionTypes = IGenericActionType<typeof eChuanDauRaChungChiActionsObj, "CHUAN_DAU_RA_CHUNG_CHI">;